import React, { useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import FormPesquisaFiltroAvancado from "./FormPesquisaFiltroAvancado";
import FormPesquisaPorAnimal from "./FormPesquisaPorAnimal";
import FormPesquisaPorGrupo from "./FormPesquisaPorGrupo";
import FormPesquisaPorGeanologia from "./FormPesquisaPorGeanologia";
import FormPesquisaPorDeps from "./FormPesquisaPorDeps";
import FormPesquisaPorNumeroRebanhos from "./FormPesquisaPorNumeroRebanhos";
import FormPesquisaPorOutrosDados from "./FormPesquisaPorOutrosDados";
import FormOpcoesApresentacao from "./FormOpcoesApresentacao";
import FormOpcoesApresentacaoFlexivel from "./FormOpcoesApresentacaoFlexivel";
import FormExportarExcel from "./FormExportarExcel";
import FormExportarPag from "./FormExportarPag";
import AnimaisFiltrados from "../List/AnimaisFiltrados";
import ClassificationStatistic from "../List/ClassificationStatistic";
import AnimaisPercentil from "../List/AnimaisPercentil";
import FichaAnimal from "../List/FichaAnimal";
import { actions } from "../../../redux/actions";
import { FormSection, HeaderBar } from "../../../components";
import { useLocation } from "react-router-dom";

// Bug preexistente corrigido aqui: quando o backend recusa a busca com 400
// (ex: "IdFazenda field is required"), o service repassa o corpo do erro como
// um OBJETO ({ type, title, status, errors: { IdFazenda: [...] } }), e o
// render antigo era so "{error}" - React nao sabe renderizar um objeto como
// filho e lança "Objects are not valid as a React child", derrubando a tela
// inteira (tela branca). Essa funcao extrai uma mensagem de texto de
// qualquer formato de erro que essa tela possa receber (string simples,
// erro de validacao do ASP.NET Core, ou objeto generico).
function getErrorMessage(error) {
  if (!error) return "";
  if (typeof error === "string") return error;

  if (error.errors && typeof error.errors === "object") {
    const mensagens = Object.values(error.errors).flat().filter(Boolean);
    if (mensagens.length > 0) return mensagens.join(" ");
  }

  if (error.title) return error.title;
  if (error.message) return error.message;

  return "Ocorreu um erro ao pesquisar. Verifique os filtros e tente novamente.";
}

export default function FormAvaliacaoGenetica({
  classificarPor,
  ordem,
  numeroPagina,
  fazendas,
  racas,
  genotipados,
  categorias,
  caracteristicas,
  caracteristicasDefault,
  situacoesAnimal,
  sexos,
  centrais,
  variedades,
  tops,
  initialConsulta,
  send,
  error,
  onRacaSelected,
  loading,
  result,
  totalAnimais,
  estatisticasClassificacao
}) {
  const location = useLocation();

  const publicHeaderItems = [
    {
      key: "filtro",
      value: "Filtro",
    },
    {
      key: "animais-filtrados",
      value: "Animais Filtrados",
    },
    {
      key: "ficha-animal",
      value: "Ficha Animal",
    },
  ];

  const privateHeaderItems = [
    {
      key: "exportar-excel",
      value: "Exportar Excel",
    },
    {
      key: "exportar-pag",
      value: "Exportar MAX PAG",
    },
    {
      key: "classificacao-estatistica",
      value: "Estatística Classificação",
    },
    {
      key: "tabela-percentil",
      value: "Tabela Percentil",
    },
  ];

  const headerItems = location.isPublicSearchRoute
    ? publicHeaderItems
    : [...publicHeaderItems, ...privateHeaderItems];

  const dispatch = useDispatch();
  const { page_filter } = useSelector((state) => state);

  const [consulta, setConsulta] = useState(initialConsulta);
  const [codAnimal, setCodAnimal] = useState(undefined);

  const handleConsulta = (obj) => {
    if (obj && Object.keys(obj).length > 0) {
      Object.keys(obj).map(function (key, index) {
        setConsulta({ ...consulta, [key]: obj[key] });
        return obj;
      });
    }
  };

  const handleSubmit = () => {
    send(consulta);
    newPageFilter("filtro");
  };

  const handleLink = (value) => {
    dispatch(actions.addNewPageFilter(value));
  };

  const handleAnimal = (value) => {
    setCodAnimal(value);
    newPageFilter("ficha-animal");
  };

  const newPageFilter = (value) => {
    dispatch(actions.addNewPageFilter(value));
  };

  const handleCurrentPage = (page) => {
    if (consulta.Page != page) {
      consulta.Page = parseInt(page);
      send(consulta);
    }
  };

  return (
    <>
      {/* <LinksBar active={page_filter} handleLink={handleLink} /> */}
      <div style={{ width: location.isPublicSearchRoute ? 535 : "100%" }}>
        <HeaderBar
          items={headerItems}
          active={page_filter}
          onClick={handleLink}
        />
      </div>
      {/* 
      {page === "animais-filtrados" && (
        <div className="btn-container">
          <button className="global-btn-info" onClick={() => createPdf()}>
            Imprimir listagem
          </button>
        </div>
      )} */}

      {page_filter === "filtro" && (
        <div className="btn-container">
          <a
            href="/submodulos/2"
            className="global-btn-info shadow-none justify-content-center"
          >
            Voltar
          </a>          
          <button
            className="global-btn-info shadow-none justify-content-center float-right"
            onClick={handleSubmit}
            style={{ width: 197 }}
          >
            Pesquisar
          </button>
        </div>
      )}
      {error && <span className="error-list">{getErrorMessage(error)}</span>}
      {page_filter === "animais-filtrados" && (
        <AnimaisFiltrados
          result={result}
          handleAnimal={handleAnimal}
          consulta={consulta}
          handleCurrentPage={handleCurrentPage}
          racas={racas}
          sexos={sexos}
          categorias={categorias}
          variedades={variedades}
          totalAnimais={totalAnimais}
        />
      )}

      {page_filter === "ficha-animal" && result && result.length === 0 && (
        <div className="mt-4">
          <h3>Faça a consulta na aba filtro</h3>
        </div>
      )}
      {page_filter === "ficha-animal" &&
        result &&
        result.length > 0 &&
        !codAnimal && (
          <div>
            <h3>Selecione um animal na aba Animais Filtrados</h3>
          </div>
        )}

      {page_filter === "ficha-animal" &&
        result &&
        result.length > 0 &&
        codAnimal && (
          <FichaAnimal
            codAnimal={codAnimal}
            setLink={handleLink}
          />
        )}

      {page_filter === "classificacao-estatistica" && (
        <ClassificationStatistic estatisticasClassificacao={estatisticasClassificacao} />
      )}

      {page_filter === "tabela-percentil" && <AnimaisPercentil racas={racas} />}

      {page_filter === "filtro" && (
        <>
          <FormPesquisaFiltroAvancado
            fazendas={fazendas}
            racas={racas}
            handleConsulta={handleConsulta}
            onRacaSelected={onRacaSelected}
          />
          <FormPesquisaPorAnimal handleConsulta={handleConsulta} />
          <FormPesquisaPorGrupo
            categorias={categorias}
            situacoesAnimal={situacoesAnimal}
            sexos={sexos}
            centrais={centrais}
            variedades={variedades}
            handleConsulta={handleConsulta}
          />
          <FormPesquisaPorGeanologia handleConsulta={handleConsulta} />
          <FormPesquisaPorDeps handleConsulta={handleConsulta} tops={tops} />
          <FormPesquisaPorNumeroRebanhos handleConsulta={handleConsulta} />
          <FormPesquisaPorOutrosDados
            genotipados={genotipados}
            classificarPor={classificarPor}
            ordem={ordem}
            numeroPagina={numeroPagina}
            handleConsulta={handleConsulta}
          />
          <FormSection
            title="Opções de apresentação"
            borderBottomWidth={241}
          ></FormSection>

          <FormOpcoesApresentacao handleConsulta={handleConsulta} />
          <FormOpcoesApresentacaoFlexivel
            handleConsulta={handleConsulta}
            caracteristicas={caracteristicas}
          />
        </>
      )}

      {page_filter === "exportar-excel" && (
        <>
          <FormExportarExcel
            caracteristicasDefault={caracteristicasDefault}
            result={result}
          />
        </>
      )}

      {page_filter === "exportar-pag" && (
        <>
          <FormExportarPag
            caracteristicasDefault={caracteristicasDefault}
            result={result}
          />
        </>
      )}
    </>
  );
}
